import { mapGetters } from "vuex"
import { orderBy } from "lodash"

import profile_utilities from "../../mixins/ProfileUtilities"
import ui_utilities from "../../mixins/UiUtilities"
import handles_stored_state from "../../mixins/HandlesStoredState"

const is_report = {
    mixins: [profile_utilities, ui_utilities, handles_stored_state],
    mounted () {
        this.$store.dispatch("FETCH_RECORDS", { entity: "user", query: { archived: true } })
        this.load()
    },
    watch: {
        $route: "load",
        profile_id: "load"
    },
    methods: {
        load () {
            if(this.report_id && this.profile_id) {
                if(!this.state.user_id) this.set_state_value("user_id", this.profile_id)

                if(!this.refreshing) this.loading = true
                this.$store.dispatch(
                    "FETCH_REPORT",
                    {
                        report_id: this.report_id,
                        data: {
                            fields: this.fields,
                            ...this.state,
                            _x: (new Date()).getTime()
                        }
                    }
                ).then(this.post_load).catch(error => {
                    this.$error(error.message)
                }).then(() => {
                    this.loading = false
                    this.refreshing = false
                })
            }
        },
        post_load (response) {
            this.versions = []
            if(response && response.meta && response.meta.versions) this.versions = response.meta.versions
        },
        reload (refreshing = true) {
            this.refreshing = refreshing
            if(!this.refreshing) this.loading = true
            this.load()
        },
        load_version (version) {
            this.set_state_value("version_id", version)
            this.reload()
        },
        route_to_project (project_id) {
            if(project_id) this.$router.push({ name: "project.edit", params: { id: project_id } })
        },
        designers_filter (user) {
            return !!user && ((user.id === this.profile_id) || ((user.role !== this.$root.constants.roles.DEVELOPER.id) && (user.role !== this.$root.constants.roles.ADMIN.id) && (user.role !== this.$root.constants.roles.BIZ_MANAGER.id)))
        },
        filter_by_user (user_id) {
            this.set_state_value("user_id", user_id)
            this.load()
        },
        datasets_set_visibility (visible) {
            this.$refs.chart._chart.data.datasets.forEach((dataset, index) => {
                this.dataset_toggle_visibility(index, visible, true)
            })
            this.$refs.chart._chart.update()
            this.$forceUpdate()
        },
        dataset_is_visible (index) {
            if(!this.$refs.chart) return false
            const meta = this.$refs.chart._chart.getDatasetMeta(index)
            return !meta.hidden
        },
        dataset_toggle_visibility (index, visible = null, bulk = false) {
            if(!this.$refs.chart) return
            const meta = this.$refs.chart._chart.getDatasetMeta(index)
            meta.hidden = (visible !== null) ? !visible : (meta.hidden ? null : true)
            if(!bulk) {
                this.$refs.chart._chart.update()
                this.$forceUpdate()
            }
        }
    },
    computed: {
        ...mapGetters(["entity_record"]),
        fields () {
            return []
        },
        studios () {
            return this.entity_records("studio")
        },
        report () {
            if(!this.report_id) return null
            return this.entity_record("report", this.report_id)
        },
        user () {
            if(this.state.user_id) return this.entity_records("user").find(user => user.id === this.state.user_id)
            return null
        },
        state_identifier () {
            return this.report_id
        },
        filterable_roles () {
            return orderBy(Object.values(this.$root.constants.roles).filter(role => role.id <= this.$root.constants.roles.PRINCIPAL.id), "id", "desc")
        }
    },
    data () {
        return {
            report_id: "",

            default_state: {
                scope: "near-future",
                mode: "absolute",
                filter: "",
                user_id: 0,
                studio_id: 0,
                version_id: 0
            },

            refreshing: false,
            loading: true,
            ymax: 0,
            versions: [],

            legend_visible: false
        }
    }
}

export default is_report
